import { render, staticRenderFns } from "./sms-tag-config.vue?vue&type=template&id=3b4cbad2&scoped=true"
import script from "./sms-tag-config.vue?vue&type=script&lang=js"
export * from "./sms-tag-config.vue?vue&type=script&lang=js"
import style0 from "./sms-tag-config.vue?vue&type=style&index=0&id=3b4cbad2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4cbad2",
  null
  
)

export default component.exports